import desktopImg from '@/public/images/onboarding/desktop-step-1.jpg'
import mobileImg from '@/public/images/onboarding/mobile-step-1.jpg'
import { Button } from 'components/common/Button'
import { Icon } from 'components/common/Icon'
import { OnboardingScreen } from 'components/onboarding/OnboardingScreen'
import { ONBOARDING_STEPS_COUNT } from 'constants/onboarding'
import { useOnboarding } from 'contexts/hooks/useOnboarding'
import { useUserProfile } from 'hooks'
import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'

export function Welcome() {
  const { t } = useTranslation('onboarding')
  const { data: userProfile } = useUserProfile()
  const { next, skip, start } = useOnboarding()

  useEffect(() => {
    if (!userProfile?.id) return
    start()
  }, [userProfile?.id])

  if (!userProfile) return null

  return (
    <OnboardingScreen desktopImg={desktopImg} mobileImg={mobileImg}>
      <button
        type='button'
        title='Close'
        onClick={skip}
        className='absolute right-6 top-6 text-cool-50 sm:text-cool-600'
      >
        <Icon name='close' size={24} className='sm:hidden' />
        <Icon name='close' className='hidden sm:block' />
      </button>

      <div className='mt-auto h-full'>
        <div className='flex h-full w-full flex-1 flex-col items-center justify-between px-8 py-6 pb-10 sm:pb-6'>
          <div className='grid h-full flex-1 items-center'>
            <div className='space-y-6'>
              <h2 className='font-body text-2xl sm:text-3xl font-medium tracking-normal'>
                {t('welcome.title', { firstName: userProfile?.firstName })}
              </h2>
              <p className='sm:text-xl'>{t('welcome.description')}</p>
            </div>
          </div>

          <div className='flex w-full flex-col space-y-1'>
            <div className='sm:hidden w-full'>
              <Button
                style='solid-primary'
                pill
                size='lg'
                onClick={next}
                className='w-full'
              >
                {t('welcome.action', { stepsCount: ONBOARDING_STEPS_COUNT })}
              </Button>
            </div>
            <div className='hidden sm:block w-full'>
              <Button
                style='solid-primary'
                pill
                size='md'
                onClick={next}
                className='w-full'
              >
                {t('welcome.action', { stepsCount: ONBOARDING_STEPS_COUNT })}
              </Button>
            </div>
            <Button style='text' pill size='md' onClick={skip}>
              {t('welcome.skip')}
            </Button>
          </div>
        </div>
      </div>
    </OnboardingScreen>
  )
}
